"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _product = require("@/api/product");
var _vuex = require("vuex");
var _permission = require("@/utils/permission");
var _creatAttr = _interopRequireDefault(require("../components/creatAttr"));
var _reservationSetting = _interopRequireDefault(require("../components/reservationSetting"));
var _ZBKJIutil = require("@/utils/ZBKJIutil");
var _auth = require("@/utils/auth");
var _edit = _interopRequireDefault(require("@/components/Category/edit.vue"));
var _merchant = require("@/api/merchant");
var _systemForm = require("@/api/systemForm");
var _useProduct2 = require("@/hooks/use-product");
var _product2 = _interopRequireDefault(require("@/mixins/product"));
var _default2 = require("./default");
var _productEnums = require("@/enums/productEnums");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _useProduct = (0, _useProduct2.useProduct)(),
  handlerCreatFromUse = _useProduct.handlerCreatFromUse;
var _default = exports.default = {
  name: 'ProductProductAdd',
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          var condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  },
  mixins: [_product2.default],
  //此js存放商品的部分函数方法
  components: {
    edit: _edit.default,
    Tinymce: _index.default,
    creatAttr: _creatAttr.default,
    reservationSetting: _reservationSetting.default
  },
  data: function data() {
    return {
      OrderSecondTypeEnum: _productEnums.OrderSecondTypeEnum,
      //批量添加规格的值
      oneFormBatch: [{
        image: '',
        price: void 0.01,
        cost: void 0.01,
        otPrice: void 0.01,
        stock: void 0,
        barCode: '',
        itemNumber: '',
        weight: void 0,
        volume: void 0,
        brokerage: void 0,
        brokerageTwo: void 0,
        cdkeyId: null,
        cdkeyLibraryName: '',
        expand: '',
        vipPrice: void 0
      }],
      frontDomain: localStorage.getItem('frontDomain'),
      htmlKey: 0,
      formThead: Object.assign({}, _default2.objTitle),
      form: 2,
      url: '',
      copyConfig: {},
      labelarr: [],
      isDisabled: this.$route.params.isDisabled === '1' ? true : false,
      isCopy: this.$route.params.isCopy === '1' ? true : false,
      //是否是采集
      editOrCopy: this.$route.params.editOrCopy,
      //编辑还是复制
      props2: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false,
        checkStrictly: true
      },
      props1: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: false,
        emitPath: false
      },
      tabs: [],
      fullscreenLoading: false,
      props: {
        multiple: true
      },
      active: 0,
      OneattrValue: [Object.assign({}, _default2.defaultObj.attrValueList[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, _default2.defaultObj.attrValueList[0])],
      // 多规格
      manyTabTit: {},
      manyTabDate: {},
      // 生成规格表格中的头部标题
      grid2: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      isBtn: false,
      manyFormValidate: [],
      currentTab: '0',
      isChoice: '',
      grid: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      ruleValidate: {
        name: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        categoryId: [{
          required: true,
          message: '请选择平台商品分类',
          trigger: 'change'
        }],
        cateIds: [{
          required: true,
          message: '请选择商户商品分类',
          trigger: 'change',
          type: 'array',
          min: '1'
        }],
        unitName: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        intro: [{
          required: true,
          message: '请输入商品简介',
          trigger: 'blur'
        }],
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }],
        image: [{
          required: true,
          message: '请上传商品图',
          trigger: 'change'
        }],
        sliderImages: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }],
        specType: [{
          required: true,
          message: '请选择商品规格',
          trigger: 'change'
        }],
        brandId: [{
          required: true,
          message: '请选择商品品牌',
          trigger: 'change'
        }],
        deliveryMethodList: [{
          required: true,
          message: '请选择配送方式',
          type: 'array',
          trigger: 'change'
        }]
      },
      tempRoute: {},
      keyNum: 0,
      isShowAttr: false,
      guaranteeList: [],
      brandList: [],
      search: {
        limit: this.$constants.page.limit[0],
        page: 1,
        cid: '',
        brandName: ''
      },
      totalPage: 0,
      total: 0,
      loading: false,
      loadingBtn: false,
      isShowGroup: 'alone',
      guaranteeGroupList: [],
      guaranteeNew: [],
      guaranteeName: [],
      multiples: true,
      productClassify: [],
      //平台商品分类
      productType: [{
        tit: '普通商品',
        id: 0,
        tit2: '实体货物'
      }, {
        tit: '云盘商品',
        id: 5,
        tit2: '同一链接发货'
      }, {
        tit: '卡密商品',
        id: 6,
        tit2: '不同充值码发货'
      }],
      upload: {
        videoIng: false // 是否显示进度条；
      },
      videoLink: '',
      //视频地址
      progress: 10,
      // 进度条默认0
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      editDialogConfig: {
        visible: false,
        isCreate: 0,
        // 0=创建，1=编辑
        prent: {},
        // 父级对象
        data: {},
        biztype: {
          name: '产品分类',
          value: 1,
          shortName: '产品'
        } // 统一主业务中的目录类型
      },
      //商品分类
      isSwitch: false,
      //商户开关
      productSwitch: false,
      //商品是否需要审核 true需要审核，false免审
      canSel: true,
      // 规格图片添加判断
      // 规格数据
      formDynamic: {
        attrsName: '',
        attrsVal: ''
      },
      formDynamics: {
        ruleName: '',
        ruleValue: []
      },
      proId: 0,
      unitList: [],
      // 商品单位列表
      unitKeyNum: 0,
      // 单位弹窗表单key
      unitStrNum: 0 // 单位选择框字符长度
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.bus.$emit('onTagsViewRefreshRouterView', this.$route.path);
    next();
  },
  computed: _objectSpread(_objectSpread({
    tagsViewList: function tagsViewList() {
      return this.$store.state.menu.tagNavList;
    },
    // 商品详情
    isInfo: function isInfo() {
      return this.currentTab === '2' && this.formValidate.type !== this.OrderSecondTypeEnum.Reservation || this.currentTab === '3' && this.formValidate.type === this.OrderSecondTypeEnum.Reservation;
    },
    // 其他设置
    isOther: function isOther() {
      return this.formValidate.type === this.OrderSecondTypeEnum.Reservation && this.currentTab === '4' || this.formValidate.type !== this.OrderSecondTypeEnum.Reservation && this.currentTab === '3';
    },
    visitedViews: function visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    }
  }, (0, _vuex.mapState)({
    systemFormList: function systemFormList(state) {
      return state.mobildConfig.systemFormList;
    }
  })), {}, {
    title: function title() {
      if (this.$route.params.id !== '0') {
        return this.isDisabled ? '商品详情' : this.editOrCopy === 'edit' ? '编辑商品' : '复制商品';
      } else {
        return '添加商品';
      }
    }
  }, (0, _vuex.mapGetters)(['merPlatProductClassify', 'merProductClassify', 'productBrand', 'shippingTemplates'])),
  created: function created() {
    this.formValidate.type = Number(this.$route.params.productType); //商品类型
    this.tempRoute = Object.assign({}, this.$route);
  },
  mounted: function mounted() {
    var _this2 = this;
    // 重置默认数据
    this.proId = Number(this.$route.params.id);
    this.getDefault();
    if ((0, _permission.checkPermi)(['merchant:plat:product:category:cache:tree'])) this.$store.dispatch('product/getAdminProductClassify');
    if (!localStorage.getItem('merProductClassify') && (0, _permission.checkPermi)(['merchant:product:category:cache:tree'])) this.$store.dispatch('product/getMerProductClassify');
    if ((0, _permission.checkPermi)(['merchant:plat:product:brand:cache:list'])) this.$store.dispatch('product/getMerProductBrand');
    if (!localStorage.getItem('shippingTemplates')) this.$store.dispatch('product/getShippingTemplates');
    if ((0, _permission.checkPermi)(['merchant:plat:product:guarantee:list'])) this.getProductGuarantee();
    if ((0, _permission.checkPermi)(['merchant:product:guarantee:group:list'])) this.getGuaranteeGroupList();
    if (!localStorage.getItem('systemFormList') && (0, _permission.checkPermi)(['merchant:system:form:page'])) this.getSystemFormList();
    this.setTagsViewTitle();
    if (this.proId != 0) {
      if ((0, _permission.checkPermi)(['merchant:product:info'])) this.getInfo();
    } else {
      this.isShowAttr = true;
    }
    if (this.isCopy && (0, _permission.checkPermi)(['merchant:plat:product:brand:cache:list'])) this.getCopyConfig();
    this.productClassify = this.addDisabled(this.merPlatProductClassify);
    this.getProductAuditSwitchInfo();
    // 获取商品单位列表
    this.getProductUnitList();
    this.$nextTick(function () {
      _this2.setSelectMaxLength();
      _this2.setupSelectListener();
    });
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapMutations)('menu', ['setTagNavList', 'closePageTagsView'])), {}, {
    checkPermi: _permission.checkPermi,
    getDefault: function getDefault() {
      if (!this.formValidate.id && this.formValidate.type === this.OrderSecondTypeEnum.Reservation) {
        this.formValidate.deliveryMethodList = ['3'];
      }
      // this.formValidate = Object.assign({}, defaultObj);
      this.formValidate.temporaryData.reservationTime = ['', '']; // 清空时间范围，让用户重新选择
      this.formValidate.attrs = [];
      this.formValidate.sliderImages = [];
      this.formValidate.supplementReservation.timeSlotSpan = 60;
      this.formValidate.temporaryData.customizeTimeClone = [['', '']];
      this.formValidate.temporaryData.reservationTime = ['', ''];
    },
    // 回调规格生成表格数据 多规格
    changeManyAttrValue: function changeManyAttrValue(e) {
      // rows数组第一项 新增默认数据 oneFormBatch
      this.ManyAttrValue = e;
    },
    // 回调规格生成表格数据 单规格
    changeOneattrValue: function changeOneattrValue(e) {
      this.OneattrValue = e;
    },
    changeIsEditVal: function changeIsEditVal() {
      this.isEditAttrVal = false;
    },
    //批量清空规格中的批量数据
    handleBatchDel: function handleBatchDel() {
      this.oneFormBatch = [{
        image: '',
        price: void 0.01,
        cost: void 0.01,
        otPrice: void 0.01,
        stock: void 0,
        weight: void 0,
        volume: void 0,
        brokerage: void 0,
        brokerageTwo: void 0,
        cdkeyId: null,
        cdkeyLibraryName: '',
        barCode: '',
        itemNumber: '',
        expand: '',
        vipPrice: void 0
      }];
    },
    //创建、编辑表单
    handlerCreatFrom: function handlerCreatFrom(id, type) {
      handlerCreatFromUse(id, type);
    },
    //系统表单数据
    getSystemFormList: function () {
      var _getSystemFormList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$systemFormPage, list;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _systemForm.systemFormPageApi)({
                page: 1,
                limit: 999
              });
            case 1:
              _yield$systemFormPage = _context.v;
              list = _yield$systemFormPage.list;
              this.$store.commit('mobildConfig/SET_SystemForm', list);
              localStorage.setItem('systemFormList', JSON.stringify(list));
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getSystemFormList() {
        return _getSystemFormList.apply(this, arguments);
      }
      return getSystemFormList;
    }(),
    //获取商户端商户商品审核开关信息
    getProductAuditSwitchInfo: function getProductAuditSwitchInfo() {
      var _this3 = this;
      (0, _merchant.productAuditSwitchInfoApi)().then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _this3.isSwitch = res.isSwitch;
                _this3.productSwitch = res.productSwitch;
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    //添加商品分类
    handleAddMenu: function handleAddMenu(rowData) {
      this.editDialogConfig.isCreate = 0;
      this.editDialogConfig.prent = rowData;
      this.editDialogConfig.data = {};
      this.editDialogConfig.visible = true;
    },
    hideEditDialog: function hideEditDialog() {
      var _this4 = this;
      this.editDialogConfig.prent = {};
      this.editDialogConfig.type = 0;
      this.editDialogConfig.visible = false;
      setTimeout(function () {
        _this4.$store.dispatch('product/getMerProductClassify');
      }, 200);
    },
    //视频上传前
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'video/mp4';
      var isLt2M = file.size / 10240 / 10240 < 2;
      if (!isJPG) {
        this.$message.error('上传视频只能是 mp4 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传视频不能超过 20MB!');
      }
      return isJPG && isLt2M;
    },
    // 上传
    handleUploadForm: function () {
      var _handleUploadForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(param) {
        var formData, data, loading, res, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              formData = new FormData();
              data = {
                model: 'product',
                pid: 0
              };
              loading = this.$loading({
                lock: true,
                text: '上传中，请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              formData.append('multipart', param.file);
              _context3.p = 1;
              _context3.n = 2;
              return (0, _ZBKJIutil.uploadImage)(formData, data);
            case 2:
              res = _context3.v;
              this.upload.videoIng = true;
              this.videoLink = res.url;
              this.progress = 100;
              loading.close();
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t = _context3.v;
              loading.close();
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function handleUploadForm(_x2) {
        return _handleUploadForm.apply(this, arguments);
      }
      return handleUploadForm;
    }(),
    // 删除视频；
    delVideo: function delVideo() {
      this.$set(this, 'videoLink', '');
    },
    //限制平台商品分类只能选择第三级
    addDisabled: function addDisabled(dropdownList) {
      var _this5 = this;
      var list = [];
      try {
        dropdownList.forEach(function (e, index) {
          var e_new = {
            id: e.id,
            name: e.name,
            level: e.level,
            pid: e.pid,
            isShow: e.isShow
          };
          if (!e.childList && (e.level === 1 || e.level === 2)) {
            e_new = _objectSpread(_objectSpread({}, e_new), {}, {
              disabled: true
            });
          }
          if (e.childList) {
            var childList = _this5.addDisabled(e.childList);
            e_new = _objectSpread(_objectSpread({}, e_new), {}, {
              childList: childList
            });
          }
          list.push(e_new);
        });
      } catch (error) {
        return [];
      }
      return list;
    },
    // 生成商品表单
    addProduct: function addProduct() {
      var _this6 = this;
      if (this.url) {
        this.formValidate.content = '';
        this.loading = true;
        this.fullscreenLoading = true;
        this.copyConfig.copyType == 1 ? (0, _product.copyProductApi)({
          url: this.url
        }).then(function (res) {
          _this6.getData(res, 'copy');
          _this6.isShowAttr = true;
          _this6.loading = false;
          _this6.fullscreenLoading = false;
        }).catch(function () {
          _this6.loading = false;
          _this6.fullscreenLoading = false;
        }) : (0, _product.importProductApi)({
          url: this.url,
          form: this.form
        }).then(function (res) {
          _this6.getData(res, 'copy');
          _this6.isShowAttr = true;
          _this6.loading = false;
          _this6.fullscreenLoading = false;
        }).catch(function () {
          _this6.loading = false;
          _this6.fullscreenLoading = false;
        });
      } else {
        this.$message.warning('请输入链接地址！');
      }
    },
    getCopyConfig: function getCopyConfig() {
      var _this7 = this;
      (0, _product.copyConfigApi)().then(function (res) {
        _this7.copyConfig = res;
      });
    },
    changeGuarantee: function changeGuarantee(val) {
      var _this8 = this;
      if (val) {
        this.guaranteeName = [];
        if (this.isShowGroup === 'combination') {
          var guaranteeGroupids = [];
          var data = this.guaranteeGroupList.filter(function (item) {
            return val.includes(item.id);
          });
          if (data.length) {
            data.map(function (itm) {
              itm.guaranteeList.map(function (item) {
                return item.isShow && guaranteeGroupids.push(item.gid);
              });
            });
          }
          this.formValidate.guaranteeIds = guaranteeGroupids.toString();
          this.guaranteeList.map(function (item) {
            guaranteeGroupids.map(function (j) {
              if (item.id === j) _this8.guaranteeName.push(item.name);
            });
          });
        }
      } else {
        this.guaranteeName = [];
        this.$set(this.formValidate, 'guaranteeIdsList', null);
      }
    },
    //选择保障服务模式
    onchangeIsShow: function onchangeIsShow() {
      this.multiples = !this.multiples;
      this.guaranteeName = [];
      this.formValidate.guaranteeIds = '';
      if (this.isShowGroup === 'combination') {
        this.guaranteeNew = this.guaranteeGroupList;
        this.$set(this.formValidate, 'guaranteeIdsList', '');
      } else {
        this.$set(this.formValidate, 'guaranteeIdsList', []);
        this.guaranteeNew = this.guaranteeList;
      }
    },
    // 服务组合列表
    getGuaranteeGroupList: function getGuaranteeGroupList() {
      var _this9 = this;
      (0, _product.guaranteeListApi)().then(function (res) {
        _this9.guaranteeGroupList = res;
      });
    },
    getLabelarr: function getLabelarr(attr) {
      this.labelarr = attr;
    },
    changeNodes: function changeNodes(data) {
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (!data[i].childList || data[i].childList.length < 1) {
            data[i].childList = undefined;
          } else {
            this.changeNodes(data[i].childList);
          }
        }
      }
      return data;
    },
    // 保障服务列表
    getProductGuarantee: function getProductGuarantee() {
      var _this0 = this;
      (0, _product.productGuaranteeApi)().then(function (res) {
        _this0.guaranteeList = res.filter(function (item) {
          return item.isShow;
        });
        _this0.guaranteeNew = _this0.guaranteeList;
      });
    },
    onChangeCategory: function onChangeCategory() {
      this.formValidate.brandId = '';
      this.brandList = [];
      this.getbrandList();
      this.brandList.push({
        name: '其他',
        id: 0
      });
    },
    // 下拉加载更多
    selectLoadMore: function selectLoadMore() {
      this.search.page = this.search.page + 1;
      if (this.search.page > this.totalPage) return;
      this.getbrandList(); // 请求接口
    },
    // 远程搜索
    remoteMethod: function remoteMethod(query) {
      var _this1 = this;
      this.loading = true;
      this.search.brandName = query;
      this.search.page = 1;
      setTimeout(function () {
        _this1.loading = false;
        _this1.getbrandList(); // 请求接口
      }, 200);
    },
    // 品牌列表
    getbrandList: function getbrandList() {
      var _this10 = this;
      this.search.cid = this.formValidate.categoryId;
      (0, _product.brandListApi)(this.search).then(function (res) {
        _this10.totalPage = res.totalPage;
        _this10.total = res.total;
        _this10.brandList = _this10.brandList.concat(res.list);
      });
    },
    proving1: function proving1(e) {
      this.formValidate.sort = e.target.value.replace(/[^\.\d]/g, '');
      this.formValidate.sort = e.target.value.replace('.', '');
    },
    handleCloseCoupon: function handleCloseCoupon(tag) {
      this.formValidate.coupons.splice(this.formValidate.coupons.indexOf(tag), 1);
      this.formValidate.couponIds.splice(this.formValidate.couponIds.indexOf(tag.id), 1);
    },
    addCoupon: function addCoupon() {
      var _this = this;
      this.$modalCoupon('wu', this.keyNum += 3, this.formValidate.coupons, function (row) {
        _this.formValidate.couponIds = [];
        _this.formValidate.coupons = row;
        row.map(function (item) {
          _this.formValidate.couponIds.push(item.id);
        });
      }, '');
    },
    setTagsViewTitle: function setTagsViewTitle() {
      if (this.$route.params.id && this.$route.params.id != 0) {
        var title = this.isDisabled ? '商品详情' : '编辑商品';
        var route = Object.assign({}, this.tempRoute, {
          title: "".concat(title, "-").concat(this.$route.params.id)
        });
        this.$store.dispatch('tagsView/updateVisitedView', route);
      } else {
        if (this.isCopy) {
          var _title = '采集商品';
          var _route = Object.assign({}, this.tempRoute, {
            title: "".concat(_title)
          });
          this.$store.dispatch('tagsView/updateVisitedView', _route);
        }
      }
    },
    // 详情
    getInfo: function getInfo() {
      var _this11 = this;
      this.fullscreenLoading = true;
      (0, _product.productDetailApi)(this.proId).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(res) {
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _context4.n = 1;
                return _this11.getData(res, 'add', _this11.editOrCopy);
              case 1:
                _this11.isShowAttr = true;
                _this11.fullscreenLoading = false;
              case 2:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this11.fullscreenLoading = false;
      });
    },
    handleRemove: function handleRemove(i) {
      this.formValidate.sliderImages.splice(i, 1);
    },
    // 上一步
    handleSubmitUp: function handleSubmitUp() {
      this.currentTab = (Number(this.currentTab) - 1).toString();
    },
    // 下一步
    handleSubmitNest: function handleSubmitNest(name) {
      var _this12 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this12.currentTab = (Number(_this12.currentTab) + 1).toString();
        } else {
          if (!_this12.formValidate.name || !_this12.formValidate.categoryId || !_this12.formValidate.keyword || !_this12.formValidate.unitName || !_this12.formValidate.intro || !_this12.formValidate.image || !_this12.formValidate.sliderImages || !_this12.formValidate.deliveryMethodList.length) {
            _this12.$message.warning('请填写完整商品信息！');
          }
        }
      });
    },
    //保存接口数据更新
    getFromData: function getFromData() {
      var _this13 = this;
      this.formValidate.id = this.proId;
      // 可约类型为每天时，具体日期为空
      if (this.formValidate.supplementReservation.reservationDateType === 1) {
        this.formValidate.supplementReservation.reservationDateStartDate = '';
        this.formValidate.supplementReservation.reservationDateEndDate = '';
        this.formValidate.supplementReservation.reservationDateWeekRange = '';
        this.formValidate.supplementReservation.reservationDateWeekRangeList = [];
      }
      if (this.formValidate.supplementReservation.timeSlotClassifyType === 2) {
        this.formValidate.timeSlotList = this.formValidate.timeSlotCustomize;
      } else {
        this.formValidate.timeSlotList = this.formValidate.timeSlotAutomatic;
      }
      //如果有视频主图，将视频链接插入到轮播图第一的位置
      if (this.videoLink) {
        if (!this.formValidate.sliderImages) {
          this.formValidate.sliderImages = [];
        }
        // 确保视频链接不在数组中
        var videoIndex = this.formValidate.sliderImages.indexOf(this.videoLink);
        if (videoIndex > -1) {
          this.formValidate.sliderImages.splice(videoIndex, 1);
        }
        this.formValidate.sliderImages.unshift(this.videoLink);
      }
      //保障服务
      if (this.isShowGroup === 'alone') this.formValidate.guaranteeIds = this.formValidate.guaranteeIdsList.join(',');
      var attrValueListData = [];
      if (this.formValidate.specType) {
        //规格值
        this.formValidate.attrList = this.formValidate.attrs.map(function (item, index) {
          return {
            attributeName: item.value,
            isShowImage: item.add_pic == 1 ? true : false,
            id: 0,
            sort: index + 1,
            optionList: item.detail.map(function (arr, idx) {
              return {
                image: arr.image,
                optionName: arr.value,
                sort: idx + 1
              };
            })
          };
        });
        //表格数据
        var ManyAttrValues = _toConsumableArray(this.ManyAttrValue);
        attrValueListData = ManyAttrValues;
        attrValueListData.shift();
        for (var i = 0; i < attrValueListData.length; i++) {
          var attrValues = _objectSpread({}, attrValueListData[i].attrValueShow);
          this.$set(attrValueListData[i], 'attrValue', JSON.stringify(attrValues)); //
        }
      } else {
        this.formValidate.attrList = [{
          attributeName: '规格',
          attrValues: '默认',
          isShowImage: false,
          optionList: [{
            optionName: '默认',
            id: 0,
            image: '',
            sort: 1
          }]
        }];
        this.OneattrValue.map(function (item) {
          _this13.$set(item, 'attrValue', JSON.stringify({
            规格: '默认'
          }));
        });
      }
      // 可约日期星期范围，1~7 - 周一~周天
      if (this.formValidate.type === this.OrderSecondTypeEnum.Reservation) this.formValidate.supplementReservation.reservationDateWeekRange = this.formValidate.supplementReservation.reservationDateWeekRangeList.join(',');
      var data = _objectSpread(_objectSpread({}, this.formValidate), {}, {
        cateId: this.formValidate.cateIds.join(','),
        keyword: this.labelarr.join(','),
        sliderImage: JSON.stringify(this.formValidate.sliderImages),
        deliveryMethod: this.formValidate.deliveryMethodList.join(','),
        systemFormId: this.formValidate.systemFormId ? this.formValidate.systemFormId : 0,
        attrValueList: this.formValidate.specType ? attrValueListData : this.OneattrValue,
        tempId: this.formValidate.type != 0 ? 0 : this.formValidate.tempId
      });

      //如果是预约商品，supplementReservation字段不传
      if (this.formValidate.type !== this.OrderSecondTypeEnum.Reservation) delete data.supplementReservation;
      return data;
    },
    //是否自动上架
    automaticListing: function automaticListing() {
      var _this14 = this;
      this.$confirm(this.productSwitch ? '审核通过之后是否自动上架？' : '操作之后是否自动上架？', '提示', {
        confirmButtonText: '上架',
        cancelButtonText: '不用了',
        type: 'warning',
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        customClass: 'deleteConfirm'
      }).then(function () {
        _this14.formValidate.isAutoUp = true;
        _this14.postData();
      }).catch(function (action) {
        if (action === 'cancel') {
          _this14.formValidate.isAutoUp = false;
          _this14.postData();
          // 调用取消按钮的方法
        } else if (action === 'close') {
          // 调用关闭按钮的方法
        }
      });
    },
    //保存并审核
    handleSubmitAndAudit: function handleSubmitAndAudit(name) {
      var _this15 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          //  this.getFromData();
          _this15.formValidate.isAutoSubmitAudit = true;
          _this15.automaticListing();
        } else {
          if (!_this15.formValidate.name || !_this15.formValidate.cateId || !_this15.formValidate.keyword || !_this15.formValidate.unitName || !_this15.formValidate.intro || !_this15.formValidate.image || !_this15.formValidate.sliderImages) {
            _this15.$message.warning('请填写完整商品信息！');
          }
        }
      });
    },
    // 保存
    handleSubmit: function handleSubmit(name) {
      var _this16 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          // this.getFromData();
          //免审商品，保存的时候弹出上架弹窗，条件：店铺开启 && 店铺免审
          if (_this16.isSwitch && !_this16.productSwitch) {
            _this16.formValidate.isAutoSubmitAudit = false;
            _this16.automaticListing();
          } else {
            _this16.formValidate.isAutoUp = false;
            _this16.formValidate.isAutoSubmitAudit = false;
            _this16.postData();
          }
        } else {
          if (!_this16.formValidate.name || !_this16.formValidate.cateId || !_this16.formValidate.keyword || !_this16.formValidate.unitName || !_this16.formValidate.intro || !_this16.formValidate.image || !_this16.formValidate.sliderImages) {
            _this16.$message.warning('请填写完整商品信息！');
          }
        }
      });
    },
    // 新增保存数据
    postData: function postData() {
      if (this.formValidate.supplementReservation.reservationDateType === 2 && !this.formValidate.supplementReservation.reservationDateStartDate && !this.formValidate.supplementReservation.reservationDateEndDate && !this.formValidate.supplementReservation.reservationDateWeekRange) {
        return this.$message.warning('设置预约服务的可预约日期不能为空');
      }
      if (this.formValidate.specType && this.formValidate.attrs.length === 0) return this.$message.warning('请填写多规格属性！');
      if (!this.formValidate.deliveryMethodList.length) return this.$message.warning('请选择服务模式');
      //勾选添加规格图,是否都上传了图片 校验判断
      var isPic = true;
      if (this.formValidate.specType) {
        this.formValidate.attrs.forEach(function (item) {
          if (item.add_pic == 1) {
            item.detail.forEach(function (itemn) {
              if (!itemn.image) {
                isPic = false;
              }
            });
          }
        });
      }
      if (!isPic) {
        this.currentTab = '2';
        return this.$message.warning('请完整添加规格图片');
      }
      this.submitForm();
    },
    // 提交表单
    submitForm: function submitForm() {
      var _this17 = this;
      this.loadingBtn = true;
      var data = this.getFromData();
      this.proId > 0 && this.editOrCopy === 'edit' ? (0, _product.productUpdateApi)(data).then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(res) {
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                _this17.$message.success('编辑成功');
                _this17.loadingBtn = false;
              case 1:
                return _context5.a(2);
            }
          }, _callee5);
        }));
        return function (_x4) {
          return _ref3.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this17.loadingBtn = false;
      }) : (0, _product.productCreateApi)(data).then(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(res) {
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.n) {
              case 0:
                _this17.$message.success('新增成功');
                if (_this17.editOrCopy === 'copy') {
                  _this17.proId = res;
                  _this17.editOrCopy = 'edit';
                } else {
                  // 返回上一页并删除tab
                  _this17.$router.go(-1);
                  _this17.closeCurrentTagsView(_this17.$route.path);
                }
                _this17.loadingBtn = false;
              case 1:
                return _context6.a(2);
            }
          }, _callee6);
        }));
        return function (_x5) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this17.loadingBtn = false;
      });
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path;
    },
    // 关闭tab标签
    closeCurrentTagsView: function closeCurrentTagsView(path) {
      this.closePageTagsView(path, '/product/list');
      this.setTagNavList(this.tagsViewList);
    },
    closeSelectedTag: function closeSelectedTag() {
      var _this18 = this;
      this.$store.dispatch('tagsView/delView', this.$route).then(function (_ref5) {
        var visitedViews = _ref5.visitedViews;
        if (_this18.isActive(_this18.$route)) {
          _this18.toLastView(visitedViews, _this18.$route);
        }
      });
    },
    toLastView: function toLastView(visitedViews, view) {
      var latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({
            path: '/redirect' + view.fullPath
          });
        } else {
          this.$router.push('/');
        }
      }
    },
    // 表单验证
    validate: function validate(prop, status, error) {
      if (status === false) {
        this.$message.warning(error);
      }
    },
    getFileType: function getFileType(fileName) {
      // 后缀获取
      var suffix = '';
      // 获取类型结果
      var result = '';
      try {
        var flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return false;
      }
      suffix = suffix.toLocaleLowerCase();
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      // 进行图片匹配
      result = imglist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'image';
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videolist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'video';
      }
      // 其他 文件类型
      return 'other';
    },
    // 获取单位列表
    getProductUnitList: function getProductUnitList() {
      var _this19 = this;
      (0, _product.productUnitListApi)().then(function (res) {
        _this19.unitList = res;
      }).catch(function (err) {
        _this19.Message.error(err.msg);
      });
    },
    // 添加单位弹窗
    handleAddUnit: function handleAddUnit() {
      var _this = this;
      this.$modalParserFrom('新建单位', 'productUnit', 0, {
        id: 0,
        name: '',
        sort: ''
      }, function (formValue) {
        _this.productUnitsave(formValue);
      }, this.unitKeyNum += 1);
    },
    // 添加单位
    productUnitsave: function productUnitsave(formValue) {
      var _this20 = this;
      var data = {
        id: formValue.id,
        name: formValue.name,
        sort: formValue.sort
      };
      (0, _product.productUnitsaveApi)(data).then(function (res) {
        _this20.$message.success('操作成功');
        _this20.$msgbox.close();
        _this20.getProductUnitList();
      }).catch(function () {});
    },
    // 设置单位选择框的字符长度
    setSelectMaxLength: function setSelectMaxLength() {
      var selectRef = this.$refs.unitSelect;
      if (selectRef) {
        // 找到内部的 input 元素
        var input = selectRef.$el.querySelector('input');
        if (input) {
          input.setAttribute('maxlength', '10');
          // // 如果需要同时设置原生 HTML 属性和响应式处理
          // input.maxLength = 5;
        }
      }
    },
    // 单位选择框输入内容监听器
    setupSelectListener: function setupSelectListener() {
      var _this21 = this;
      var selectRef = this.$refs.unitSelect;
      if (!selectRef) return;
      var input = selectRef.$el.querySelector('input');
      if (!input) return;
      input.addEventListener('input', function (event) {
        _this21.unitStrNum = event.target.value.length;
      });
    },
    // 修改单位值
    changeUnitSelect: function changeUnitSelect() {
      this.unitStrNum = this.formValidate.unitName.length;
    }
  })
};